import { Button } from '@superops/ui-design-system';
import { useActivityTracker } from '@nile/components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function InsightCell(props) {
  const { cell } = props;
  const { column, row } = cell || {};
  const { actions = null } = column;

  const onClickEvent = () => {
    if (!actions) return;

    actions(row?.original?.clientId);
    useActivityTracker({
      event: 'EFFICIENCY_DELVE_DEEPER_CLIENT',
      data: {
        clientName: row?.original?.clientName
      }
    });
  };
  return (
    <Button
      plain
      onClick={() => {
        const section = document.getElementById('CLIENT_WISE_EFFICIENCY');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
        onClickEvent();
      }}
    >
      <FormattedMessage id="common.label.viewInsight" />
    </Button>
  );
}

export default InsightCell;
